
export interface CustomerCreateAccount {
    email: string
    username: string
    phone: string
    password: string
    confirmPassword: string
}

export interface CustomerLogin {
    email: string
    password: string
}

interface ValidCustomer {
    isValid: boolean
    message?: string
}

namespace LoginValidations {
    export const getCustomerDataValidation = ({ email, password }: CustomerLogin, validatePassword = false): ValidCustomer => {
        const validCustomer: ValidCustomer = { isValid: true }

        const validEmail = isValidEmail(email)

        if (!validEmail.isValid) {
            validCustomer.message = validEmail.message
            validCustomer.isValid = false
        }

        if (!password && validatePassword) {
            validCustomer.message = "Informe sua senha!"
            validCustomer.isValid = false
        }

        return validCustomer
    }

    export const createAccountValidation = ({ email, username, phone, password, confirmPassword }: CustomerCreateAccount) => {
        const validCustomer: ValidCustomer = { isValid: true }
        const validEmail = isValidEmail(email)

        if (!validEmail.isValid) {
            validCustomer.message = validEmail.message
            validCustomer.isValid = false
        }
        else if (!username) {
            validCustomer.message = "Informe um nome para seu usuário!"
            validCustomer.isValid = false
        }
        if (username.length < 3) {
            validCustomer.message = "O nome deve 3 ou mais caracteres!"
            validCustomer.isValid = false
        }
        else if (!phone) {
            validCustomer.message = "Informe um telefone!"
            validCustomer.isValid = false
        }
        else if (!phone.isValidPhoneNumber()) {
            validCustomer.message = "Informe um número de telefone válido!"
            validCustomer.isValid = false
        }
        else if (!password) {
            validCustomer.message = "Informe uma senha!"
            validCustomer.isValid = false
        }
        else if (password.length < 6) {
            validCustomer.message = "A senha inserida deve conter pelo menos 6 caracteres!"
            validCustomer.isValid = false
        }
        else if (!confirmPassword) {
            validCustomer.message = "Confirme sua senha!"
            validCustomer.isValid = false
        }
        else if (password !== confirmPassword) {
            validCustomer.message = "As senhas informadas diferem!"
            validCustomer.isValid = false
        }

        return validCustomer
    }

    export const updateAccountValidation = (username: string, phone: string) => {
        const validCustomer: ValidCustomer = { isValid: true }

        if (!username) {
            validCustomer.message = "Informe o nome."
            validCustomer.isValid = false
        }
        else if (username.length < 3) {
            validCustomer.message = "O nome deve ter 3 ou mais caracteres."
            validCustomer.isValid = false
        }
        else if (!phone) {
            validCustomer.message = "Informe o telefone."
            validCustomer.isValid = false
        }
        else if (!phone.isValidPhoneNumber()) {
            validCustomer.message = "Informe o número de telefone válido!"
            validCustomer.isValid = false
        }

        return validCustomer
    }

    export const updatePasswordValidation = (currentPassword: string, newPassword: string, confirmNewPassword: string) => {
        const validCustomer: ValidCustomer = { isValid: true }

        if (!currentPassword) {
            validCustomer.message = "Informe a senha atual."
            validCustomer.isValid = false
        }
        else if (!newPassword) {
            validCustomer.message = "Informe a nova senha."
            validCustomer.isValid = false
        }
        else if (!confirmNewPassword) {
            validCustomer.message = "Informe a confirmação de senha."
            validCustomer.isValid = false
        }
        else if (newPassword.length < 6) {
            validCustomer.message = "A nova senha deve ter no mínimo 6 caracteres."
            validCustomer.isValid = false
        }
        else if (newPassword === currentPassword) {
            validCustomer.message = "A nova senha deve ser diferente da senha atual."
            validCustomer.isValid = false
        }
        else if (newPassword !== confirmNewPassword) {
            validCustomer.message = "As senhas não conferem."
            validCustomer.isValid = false
        }

        return validCustomer
    }

    const isValidEmail = (email: string) => {
        const validCustomer: ValidCustomer = { isValid: true }
        const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

        if (!email) {
            validCustomer.message = "Informe um e-mail!"
            validCustomer.isValid = false
        }

        if (email && !regexp.test(email)) {
            validCustomer.message = "Informe um e-mail válido!"
            validCustomer.isValid = false
        }

        return validCustomer
    }
}

export default LoginValidations